const storagePrefix = 'yuanling.h5.'
const set = (key: string, data: any) => localStorage.setItem(`${storagePrefix}${key}`, data )

const get = (key: string) => localStorage.getItem(`${storagePrefix}${key}`)
const remove = (key: string) => localStorage.removeItem(`${storagePrefix}${key}`)

export default { get, set, remove }